module.exports = "<ea-user-detail-page></ea-user-detail-page>\n"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaSettings/eaUser/eaUserDetailPage/eaUserDetailPageModule.html
// module id = 1072
// module chunks = 12